import { render, staticRenderFns } from "./MovedAbroad.vue?vue&type=template&id=4e56efe6"
import script from "./MovedAbroad.vue?vue&type=script&lang=js"
export * from "./MovedAbroad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports